import firebase from "../firebase";

const newsRef = firebase.firestore().collection("News");
const imageRef = firebase.storage().ref('images/newss');

export async function addNews({ commit },  { id, statement }) {
  const ref = newsRef.doc(id);
  await ref.set({ ...statement });
  commit("addNews", { id, statement });
}

export async function editNews({ commit, state },  { id, itemID, statement }) {
  let old = state.news.filter((doc) => doc.id === itemID)[0];
  if (statement.image && old.image !== statement.image) {
    await imageRef.child(`${itemID}/${old.image}`).delete();
  }
  await newsRef.doc(itemID).update({ ...statement });
  commit("editNews", { itemID, statement });
}

export async function delNews({ commit },  { id, itemID, statement }) {
  await imageRef.child(`${itemID}/${statement.image}`).delete();
  await newsRef.doc(itemID).delete();
  commit("delNews", itemID);
}
